<template>
    <div>
        <title-component title="Roles" subtitle="Listado de roles"></title-component>
        <table-screen v-if="display.table == true" v-on:screen="Screen"></table-screen>
        <add-screen v-if="display.add == true"  v-on:screen="Screen"></add-screen>
        <edit-screen v-if="display.edit == true"  v-on:screen="Screen"></edit-screen>
    </div>
</template>
<script>
import TitleComponent from '@/components/title.vue'
import TableScreen from './table.vue'
import AddScreen from './add.vue'
import editScreen from './edit.vue'
export default {
    components:{
        TitleComponent,
        TableScreen,
        AddScreen,
        editScreen
    },
    data() {
        return {
            display:{
                table:true,
                add:false,
                edit:false
            }
        };
    },
    mounted() {
        
    },
    methods: {
        Screen(item){
            this.display = item
        }
    },
};
</script>